<template>
  <div class="page-outer">
    <div class="preview-wrap">
      <div class="item-card" v-for="item of planList" :key="item.campaignName">
        <ul class="msg-list">
          <li class="masg-item campaing-wrap">
            <span class="lable">Campaign名称：</span>
            <span class="value">{{ item.campaignName }}</span>
          </li>
          <li class="masg-item">
            <span class="lable">广告账号：</span>
            <span class="value">{{ item.advertisrId }}</span>
          </li>
          <li class="masg-item">
            <span class="lable">预算：</span>
            <span class="value">
              <div v-if="item.budgetMode === 'BUDGET_MODE_DAY_SCHEDULE'">
                <div class="budget-title">分日预算</div>
                <div class="budget-item">
                  {{ JSON.parse(item.dayBudgetSchedule)[0] + " CNY(星期一)" }}
                </div>
                <div class="budget-item">
                  {{ JSON.parse(item.dayBudgetSchedule)[1] + " CNY(星期二)" }}
                </div>
                <div class="budget-item">
                  {{ JSON.parse(item.dayBudgetSchedule)[2] + " CNY(星期三)" }}
                </div>
                <div class="budget-item">
                  {{ JSON.parse(item.dayBudgetSchedule)[3] + " CNY(星期四)" }}
                </div>
                <div class="budget-item">
                  {{ JSON.parse(item.dayBudgetSchedule)[4] + " CNY(星期五)" }}
                </div>
                <div class="budget-item">
                  {{ JSON.parse(item.dayBudgetSchedule)[5] + " CNY(星期六)" }}
                </div>
                <div class="budget-item">
                  {{ JSON.parse(item.dayBudgetSchedule)[6] + " CNY(星期日)" }}
                </div>
              </div>
              <span v-else>{{ item.dayBudgetSchedule }}</span>
            </span>
          </li>
        </ul>
        <div class="table-wrap">
          <el-table :data="item.previewEntities" style="width: 100%">
            <el-table-column label="广告组">
              <template slot-scope="scope">
                <div class="cell-wrap">
                  <span>{{ scope.row.adSetName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="预算与出价">
              <template slot-scope="scope">
                <div class="cell-wrap">
                  <span class="cell-label">预算</span>
                  <span class="cell-value">{{ scope.row.budget }}</span>
                  <span class="cell-label">计费方式</span>
                  <span class="cell-value">{{ scope.row.chargeMode }}</span>
                  <span class="cell-label">出价</span>
                  <span class="cell-value">{{ scope.row.cpaBid }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="定向">
              <template slot-scope="scope">
                <div class="cell-wrap">
                  <span class="cell-label">性别</span>
                  <span class="cell-value">{{ scope.row.gender }}</span>
                  <span class="cell-label">自定义人群</span>
                  <span class="cell-value"
                    >{{ scope.row.audienceType }}
                    <el-tooltip placement="top">
                      <div slot="content">
                        <div class="hover-wrap" style="font-size: 12px">
                          <div style="font-weight: bold">定向</div>
                          <div style="margin-top: 6px">
                            {{
                              scope.row.audience &&
                              scope.row.audience.retargeting_tags_include
                                ? scope.row.audience.retargeting_tags_include.join()
                                : "-"
                            }}
                          </div>
                          <div style="margin-top: 10px; font-weight: bold">
                            排除
                          </div>
                          <div style="margin-top: 6px">
                            {{
                              scope.row.audience &&
                              scope.row.audience.retargeting_tags_exclude
                                ? scope.row.audience.retargeting_tags_exclude.join()
                                : "-"
                            }}
                          </div>
                        </div>
                      </div>
                      <i
                        v-show="scope.row.audienceType === '自定义'"
                        class="el-icon-question"
                      ></i>
                    </el-tooltip>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="创意分类及标签">
              <template slot-scope="scope">
                <div class="cell-wrap">
                  <span class="cell-label">创意分类</span>
                  <el-cascader
                    class="table-cascader"
                    v-model="scope.row.creativeCategory"
                    placeholder="-"
                    :options="industryList"
                    :props="{
                      value: 'category_id',
                      label: 'category_name',
                      emitPath: false,
                    }"
                    style="width: 240px"
                    :disabled="true"
                  ></el-cascader>
                  <span class="cell-label">创意标签</span>
                  <span class="cell-value">{{ scope.row.creativeLabel }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="广告创意">
              <template slot-scope="scope">
                <div class="cell-wrap">
                  <span class="cell-label">{{
                    scope.row.creativeGroupName
                  }}</span>
                  <span class="cell-value">{{ scope.row.videoNum }}个视频</span>
                  <span class="cell-value">{{ scope.row.imageNum }}个图片</span>
                  <span class="cell-value">{{ scope.row.titleNum }}个标题</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="bottom-btnlist">
      <el-button class="bot-btn" @click="goBack">返回</el-button>
      <el-button
        class="bot-btn primary"
        :loading="pushLoading"
        @click="pushAdvertise"
        >发布广告</el-button
      >
    </div>
  </div>
</template>

<script>
import {
  queryCreativeCategory,
  audience,
  publish,
} from "@/api/promotion-kuaishou.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      pushLoading: false,
      planList: [],
      industryList: [],
      templateId: null, //当前预览的id
    };
  },
  activated() {
    this.initData();
    this.initTableOptions();
  },
  methods: {
    initTableOptions() {
      //创意分类列表
      queryCreativeCategory({
        advertiserId: this.adCount.advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          this.industryList = res.categories;
        }
      });
      //人群包列表
      audience({
        advertiserId: this.adCount.advertiserId,
      }).then((res) => {
        if (res.code === "0000") {
          let audienceList = res.audiencePacks;
          console.log(audienceList);
          //格式化人群包数据
          this.planList.forEach((planItem) => {
            planItem.previewEntities = planItem.previewEntities.map((row) => {
              if (row.audience) {
                row.audience.retargeting_tags_exclude = row.audience
                  .retargeting_tags_exclude
                  ? row.audience.retargeting_tags_exclude.map((exid) => {
                      let item = audienceList.find(
                        (i) => i.orientation_id == exid
                      );
                      return item ? item.orientation_name : "-";
                    })
                  : [];

                row.audience.retargeting_tags_include = row.audience
                  .retargeting_tags_include
                  ? row.audience.retargeting_tags_include.map((inid) => {
                      let item = audienceList.find(
                        (i) => i.orientation_id == inid
                      );
                      return item ? item.orientation_name : "-";
                    })
                  : [];
              }
              return row;
            });
          });
        }
      });
    },
    initData() {
      let previewData = this.$route.params.previewData;
      this.templateId = this.$route.params.templateId;
      if (previewData) {
        this.planList = previewData;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    pushAdvertise() {
      this.pushLoading = true;
      publish({
        templateId: this.templateId,
      }).then((res) => {
        this.pushLoading = false;
        if (res.code === "0000") {
          this.$message({
            message: "计划发布成功",
            type: "success",
          });
          this.$router.replace("/promotion.html/proTable");
        }
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionKuaishou.adCount,
    }),
  },
};
</script>

<style lang="less" scoped>
.page-outer {
  .preview-wrap {
    margin: 16px;
    .item-card {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      padding: 24px;
      box-sizing: border-box;
      margin-bottom: 16px;
      .msg-list {
        padding: 0px;
        margin: 0px;
        list-style: none;
        .masg-item {
          display: flex;
          margin-bottom: 24px;
          font-size: 12px;
          color: #000;
          &.campaing-wrap {
            border-bottom: 1px solid rgb(232, 234, 236);
            padding-bottom: 16px;
          }
          .lable {
            font-weight: bold;
            flex-shrink: 0;
            width: 140px;
          }
          .value {
            width: 100%;
            .budget-title {
              font-size: 12px;
              color: #000;
              font-weight: bold;
              padding-bottom: 6px;
            }
            .budget-item {
              padding: 6px 0;
            }
          }
        }
      }
      .table-wrap {
        padding-top: 24px;
        /deep/ td {
          vertical-align: top;
        }
        .cell-wrap {
          .cell-label {
            display: block;
            color: rgba(0, 0, 0, 0.65);
            font-weight: bold;
            font-size: 14px;
            // margin-top: 6px;
          }
          .cell-value {
            display: block;
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
          }
          .table-cascader {
            line-height: 0px !important;
            /deep/ input {
              border: none;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
              background-color: transparent;
              padding: 0px;
              height: 15px;
            }
            /deep/ .el-input {
              line-height: 15px !important;
            }
            /deep/ .el-input__suffix {
              display: none;
            }
          }
          .table-cascader {
            line-height: 0px !important;
            /deep/ input {
              border: none;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
              background-color: transparent;
              padding: 0px;
              height: 15px;
            }
            /deep/ .el-input {
              line-height: 15px !important;
            }
            /deep/ .el-input__suffix {
              display: none;
            }
          }
        }
      }
    }
  }
  .bottom-btnlist {
    height: 100px;
    padding-left: 16px;
    .bot-btn {
      height: 40px;
      width: 117px;
      color: rgba(24, 144, 255, 1);
      font-size: 14px;
      border-radius: 2px;
      border: 1px solid rgba(24, 144, 255, 1);
      &.primary {
        color: #fff;
        background: rgba(24, 144, 255, 1);
      }
    }
  }
}
</style>